export const SET_METADATAS = 'SET_METADATAS';
export const DELETE_METADATA = 'DELETE_METADATA';
export const SET_PAGINATION = 'SET_PAGINATION';
export const CREATE_METADATA = 'CREATE_METADATA';
export const UPDATE_METADATA = 'UPDATE_METADATA';
export const SET_METADATA = 'SET_METADATA';
export const SET_LIMIT = 'SET_LIMIT';
